import { queryClient } from '../../page/ReactQueryProvider';
import { makeUrl } from '../../tools/strings';
import { DataResults, HTTPMethod } from '../../types';

import stringify from 'fast-json-stable-stringify';
import { dataClient } from '../data.client';

export const getData = async ({
  urlRoot,
  endpoint,
  dataParams,
  dataRequestId,
  requestMethod,
  collection,
  cachedData,
}: {
  urlRoot: string;
  endpoint: string;
  dataParams: any;
  dataRequestId: string;
  requestMethod: HTTPMethod;
  collection: any;
  cachedData: DataResults;
}) => {
  const queryKey = getQueryKeyForData({ dataParams, urlRoot, endpoint });

  if (cachedData) {
    return cachedData;
  }

  return await queryClient.fetchQuery({
    queryKey,
    queryFn: () => dataClient.getData(makeUrl(urlRoot, endpoint), dataParams, dataRequestId, requestMethod, collection),
    staleTime: Infinity,
  });
};

export const updateDataRequestIdFromCacheData = async ({ queryKey, dataRequestId }) => {
  const cacheData = await queryClient.getQueryData(queryKey);
  if (!cacheData) {
    return undefined;
  }
  await queryClient.setQueryData(queryKey, (oldData: any) => ({
    ...oldData,
    requestId: dataRequestId,
  }));
  return cacheData;
};

export const getQueryKeyForData = ({ dataParams, urlRoot, endpoint }) => {
  const isBasicData = !dataParams?.uiEnrichments?.length;
  const queryKeyType = isBasicData ? 'data' : 'enrichmentData';
  const queryKey = [queryKeyType, urlRoot, endpoint, stringify(dataParams)];
  return queryKey;
};
